import { useNavigate } from "react-router-dom";
import { useImpersonation } from "@/hooks/useImpersonation";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/lib/firebase";
import { Eye, X } from "lucide-react";

const logImpersonationFn = httpsCallable(functions, "logImpersonation");

export function ImpersonationBanner() {
  const navigate = useNavigate();
  const { isImpersonating, orgId, orgName, returnPath, stopImpersonation } =
    useImpersonation();

  if (!isImpersonating) return null;

  function handleExit() {
    if (orgId) {
      logImpersonationFn({ orgId, action: "stop" }).catch(console.error);
    }
    const path = returnPath ?? "/admin/orgs";
    stopImpersonation();
    navigate(path, { replace: true });
  }

  return (
    <div className="flex items-center justify-between gap-4 border-b border-amber-300 bg-amber-50 px-4 py-2">
      <div className="flex items-center gap-2">
        <Eye className="h-4 w-4 text-amber-600" />
        <span className="font-body text-sm text-amber-800">
          Viewing as <strong>{orgName}</strong>
        </span>
      </div>
      <button
        onClick={handleExit}
        className="inline-flex items-center gap-1 rounded-md bg-amber-600 px-3 py-1 font-heading text-xs font-semibold text-white transition-colors hover:bg-amber-700"
      >
        <X className="h-3 w-3" />
        Exit
      </button>
    </div>
  );
}
